import { MatDialog } from "@angular/material/dialog";
import type { OrderItemPreviewRequest } from "../../card-orders/card-orders.interface";
import { PrintCardOrderItemPreviewDialogComponent } from "./print-card-order-item-preview-dialog.component";

export function openPrintCardOrderItemPreviewDialog(
  dialog: MatDialog,
  data: OrderItemPreviewRequest,
): void {
  dialog.open(PrintCardOrderItemPreviewDialogComponent, {
    width: data.mode === "order" ? "980px" : "920px",
    maxWidth: "98vw",
    autoFocus: false,
    panelClass: "app-dialog-panel",
    data,
  });
}
